import { LoanDocState, TaskState } from 'gql/graphql';
import { Phases } from '../../LoanPhase.constanst';
import { getTaskIcon } from './processorPhaseStates';

export const processBorrowerTaskItems = (
  _phase: any,
  loanDocs: any[],
  loan: any,
  tasks: any[]
) => {
  // `tasks` son las cards por-loan ya calculadas por getTasks() (LoanDetails.tsx).
  // NO se debe re-derivar ni mutar el singleton RulesTasksCards aquí: eso filtra el estado
  // de las tasks de un loan al siguiente loan abierto en la misma sesión.
  const rulesTasksCardsNotHidden = (tasks || []).filter(
    (item: any) => !item.data?.hidden && item.state !== undefined
  );

  // Procesar borrower items task para la fase específica (lógica original processing)
  const filteredRulesTaskCards = rulesTasksCardsNotHidden.filter(item =>
    item.phaseProgress === _phase.key as Phases &&
    (!item.loanType || item.loanType?.includes(loan?.type)) &&
    (!item.loanPurposes || item.loanPurposes?.includes(loan?.purpose))
  );

  rulesTasksCardsNotHidden.forEach((taskCard, index) => {
    if (
      taskCard.phaseProgress === _phase.key as Phases &&
      (!taskCard.loanType || taskCard.loanType?.includes(loan.type)) &&
      (!taskCard.loanPurposes || taskCard.loanPurposes?.includes(loan?.purpose))
    ) {
      const buttonState = taskCard.progressButtons && taskCard.state !== undefined
        ? taskCard.progressButtons[taskCard.state]
        : undefined;

      const loanDocBlocked = loanDocs?.find(item =>
        item.state === LoanDocState.Blocking &&
        taskCard.state !== TaskState.Approved &&
        taskCard.state !== TaskState.Review &&
        taskCard.key.includes(item.key)
      );

      const loanDocRef = loanDocs?.find(item =>
        taskCard.key.includes(item.key) &&
        item.file?.url &&
        !item.hidden
      );

      // Crear el item task de borrower (lógica original processing)
      _phase.tasksItems.push({
        id: index,
        key: taskCard.key,
        modalKey: taskCard.modalKey,
        icon: getTaskIcon(taskCard.state ?? '', _phase.state),
        text: taskCard.name,
        titleButton: (buttonState ? buttonState.label : 'View'),
        state: loanDocBlocked ? 'BLOCKED' : taskCard.state,
        loanDoc: loanDocRef
      });
    }
  });

  return filteredRulesTaskCards;
};